import { render, staticRenderFns } from "./TabsBase.vue?vue&type=template&id=cc3ba68c&scoped=true&"
import script from "./TabsBase.vue?vue&type=script&lang=ts&"
export * from "./TabsBase.vue?vue&type=script&lang=ts&"
import style0 from "./TabsBase.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TabsBase.vue?vue&type=style&index=1&id=cc3ba68c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3ba68c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VLayout,VTab,VTabs,VTabsSlider})
